module.exports = __webpack_public_path__ + "static/media/ts.2239d0f1.svg";